import { Product } from "@interfaces/dto/products.dto";
import Link from "next/link";
import PriceItem from "@components/features/product-list/items/PriceItem";
import { isWebview, hideMenuBarNative } from "@utils/webview.util";
import { PRODUCT_NOT_FOUND_IMG } from "@const/products.const";
interface Props {
  dataRelated: Product[];
}

const RelatedItemOnModal = ({ dataRelated }: Props) => {
  return (
    <>
      {dataRelated.map((data, id) => {
        return (
          <div key={id} className="col-6 col-md-3">
            <Link href={`/products/${data.url_key}`}>
              <a
                className="card justify-content-center border-1"
                onClick={() => {
                  if (isWebview()) {
                    hideMenuBarNative();
                  }
                }}
              >
                <img
                  src={data.image ? data.image : PRODUCT_NOT_FOUND_IMG}
                  className="card-img-top"
                  alt={data.name}
                />
                <div className="card-body align-items-center">
                  <h4 className="name">{data.name}</h4>
                  <PriceItem
                    saleAble={data.saleable}
                    dataPrice={data.price}
                    dataSpecialPrice={data.special_price}
                  />
                </div>
              </a>
            </Link>
          </div>
        );
      })}
    </>
  );
};

export default RelatedItemOnModal;
